import { Link } from "react-router-dom";
import { useContent } from "../lib/content";
import { SEO } from "../components/SEO";

export default function Privacy() {
  const c = useContent("privacy");
  return (
    <div data-testid="page-privacy" className="py-20 md:py-28">
      <SEO path="/confidentialite" title="Politique de confidentialité (RGPD) — ECO-GEST PATRIMOINE" description="Politique de confidentialité et de protection des données personnelles d'ECO-GEST PATRIMOINE — conforme RGPD." />
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <p className="overline mb-4"><span className="red-dot" />{c.hero_kicker}</p>
        <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight mb-8">{c.hero_title}</h1>

        {c.intro && (
          <p className="text-gray-600 leading-relaxed mb-12">{c.intro}</p>
        )}

        <div className="space-y-10">
          {(c.sections || []).map((s, i) => (
            <section key={i} data-testid={`privacy-section-${i}`}>
              <h2 className="font-display text-lg md:text-xl font-bold tracking-tight mb-3 pb-2 border-b border-gray-200">
                {s.title}
              </h2>
              <p className="text-gray-700 leading-relaxed whitespace-pre-line">{s.body}</p>
            </section>
          ))}
        </div>

        {c.last_update && (
          <p className="mt-12 text-xs uppercase tracking-[0.2em] text-gray-400">{c.last_update}</p>
        )}

        <div className="mt-12 flex flex-wrap gap-6 text-sm">
          <Link to="/" className="uppercase tracking-wide border-b border-[#E60000] pb-1 hover:text-[#E60000]" data-testid="privacy-back-home">Retour à l'accueil</Link>
          <Link to="/mentions-legales" className="uppercase tracking-wide text-gray-600 hover:text-[#E60000]" data-testid="privacy-to-legal">Mentions légales</Link>
        </div>
      </div>
    </div>
  );
}
